import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../../context/app-context';

export function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function useAppContext() {
  return useContext(AppContext);
}

export function useAppInfo() {
  return useContext(AppContext).appInfo;
}
